<div class="custom-reports">
  <div class="reports-content">
    <div class="report-titles">
      <h2>create a custom report</h2>
      <h3>select the characteristics you want to search for, then click 'search'.</h3>
      <!-- <h3>create a custom report: select the characteristics you want to search for, then click 'search'.</h3> -->
    </div>

    <!-- <h1>custom report</h1>
    <h4>
      create a custom report: select the characteristics you want to search for, then click 'search'.
    </h4> -->

    <form #customReportsForm>
      <div class="form-group">
        <span [ngbPopover]="reportsCopy.team" triggers="hover" placement="right"> team: </span>
        <checkbox-select
          [options]="teams"
          [selectedOptions]="customReport.selectedTeams"
          (selectOption)="onSelectTeam($event)"
        ></checkbox-select>
      </div>
      <div class="form-group right-align">
        <span [ngbPopover]="reportsCopy.pcnNumber" triggers="hover" placement="left">
          PCN number:
        </span>
        <input
          aria-label=""
          class="reports-input"
          type="text"
          placeholder="All"
          name="pcnNumber"
          [(ngModel)]="customReport.pcnNumber"
        />
      </div>

      <div class="form-group">
        <span [ngbPopover]="reportsCopy.user" triggers="hover" placement="right"> user: </span>
        <checkbox-select
          [options]="users"
          [selectedOptions]="customReport.usersIds"
          (selectOption)="onSelectUser($event)"
        ></checkbox-select>
      </div>
      <div class="form-group right-align">
        <span [ngbPopover]="reportsCopy.contravention" triggers="hover" placement="left">
          contravention:
        </span>
        <checkbox-select
          [options]="contraventions"
          [selectedOptions]="customReport.selectedContraventions"
          (selectOption)="onSelectContravention($event)"
        ></checkbox-select>
      </div>

      <div class="form-group">
        <span [ngbPopover]="reportsCopy.startDate" triggers="hover" placement="right">
          start date:
        </span>
        <p-calendar
          class="primeng-date"
          [(ngModel)]="customReport.startDate"
          [readonlyInput]="true"
          dateFormat="dd/mm/yy"
          name="startDate"
          [maxDate]="customReport.endDate"
        ></p-calendar>
      </div>
      <div class="form-group right-align">
        <span [ngbPopover]="reportsCopy.stage" triggers="hover" placement="left"> stage: </span>
        <checkbox-select
          [options]="stages"
          [selectedOptions]="customReport.stages"
          (selectOption)="onSelectStage($event)"
        ></checkbox-select>
      </div>

      <div class="form-group">
        <span [ngbPopover]="reportsCopy.endDate" triggers="hover" placement="right">
          end date:
        </span>
        <p-calendar
          class="primeng-date"
          [(ngModel)]="customReport.endDate"
          [readonlyInput]="true"
          dateFormat="dd/mm/yy"
          name="startDate"
          [minDate]="customReport.startDate"
        ></p-calendar>
      </div>
      <div class="form-group right-align">
        <span [ngbPopover]="reportsCopy.bespoke" triggers="hover" placement="left"> bespoke: </span>
        <checkbox-select
          [options]="bespoke"
          [selectedOptions]="customReport.selectedBespoke"
          (selectOption)="onSelectBespoke($event)"
        ></checkbox-select>
      </div>

      <div class="form-group">
        <span [ngbPopover]="reportsCopy.pcnType" triggers="hover" placement="right">
          PCN type:
        </span>
        <checkbox-select
          [options]="pcnTypes"
          [selectedOptions]="customReport.selectedPcnTypes"
          (selectOption)="onSelectPcnType($event)"
        ></checkbox-select>
      </div>
      <div class="form-group right-align">
        <span [ngbPopover]="reportsCopy.pcnType" triggers="hover" placement="left">
          decision:
        </span>
        <checkbox-select
          [options]="decisions"
          [selectedOptions]="customReport.selectedDecisions"
          (selectOption)="onSelectDecision($event)"
        ></checkbox-select>
      </div>

      <div class="form-group">
        <span [ngbPopover]="reportsCopy.pcnPrefix" triggers="hover" placement="right">
          PCN prefix:
        </span>
        <checkbox-select
          [options]="pcnPrefixes"
          [selectedOptions]="customReport.selectedPcnPrefixes"
          (selectOption)="onSelectPcnPrefix($event)"
        ></checkbox-select>
      </div>
      <div class="form-group right-align">
        <span [ngbPopover]="reportsCopy.provokedUfu" triggers="hover" placement="left">
          provoked UFU:
        </span>
        <checkbox-select
          [options]="ufus"
          [selectedOptions]="customReport.selectedUfus"
          (selectOption)="onSelectUfu($event)"
        ></checkbox-select>
      </div>

      <div class="form-group">
        <span [ngbPopover]="reportsCopy.override" triggers="hover" placement="right">
          override:
        </span>
        <checkbox-select
          [options]="overrides"
          [selectedOptions]="customReport.selectedOverrides"
          (selectOption)="onSelectOverride($event)"
        ></checkbox-select>
      </div>

      <!-- <div class="form-group right-align">
        <span [ngbPopover]="reportsCopy.reason" triggers="hover" placement="right"> reason: </span>
        <checkbox-select
          [options]="reasons"
          [selectedOptions]="customReport.selectedReasons"
          (selectOption)="onSelectReason($event)"
        ></checkbox-select>
      </div> -->

      <div class="form-group right-align">
        <span [ngbPopover]="reportsCopy.location" triggers="hover" placement="right">
          Location:
        </span>
        <input
          aria-label=""
          class="reports-input"
          type="text"
          placeholder="All"
          name="location"
          [(ngModel)]="customReport.location"
        />
      </div>

      <div class="clear"></div>

      <div class="download-btns">
        <button
          class="app-submit search"
          (click)="searchReports()"
          [ngClass]="{ disabled: !isSearchEnable(), searching: searchingState }"
        >
          {{ searchingState ? 'Searching...' : 'Search' }}
        </button>
        <button
          class="app-submit secondary"
          (click)="downloadDocument('pdf')"
          [ngClass]="{
            disabled: reportsResult.length === 0 || reportsResult.length > maxReportRows
          }"
        >
          PDF&nbsp;&nbsp;
          <img [src]="constants.assetsPath + '/img/icons/download-white.svg'" width="14" />
        </button>
        <button
          class="app-submit secondary"
          (click)="downloadDocument('excel')"
          [ngClass]="{
            disabled: reportsResult.length === 0 || reportsResult.length > maxReportRows
          }"
        >
          EXCEL&nbsp;&nbsp;
          <img [src]="constants.assetsPath + '/img/icons/download-white.svg'" width="14" />
        </button>
      </div>
    </form>

    <div class="custom-reports-result">
      <h4 *ngIf="reportsResult.length === 0">No results.</h4>
      <h4 *ngIf="reportsResult.length > maxReportRows">
        Your report contains {{ reportsResult.length }}
        {{ reportsResult.length === 1 ? 'row' : 'rows' }}. The maximum allowed rows are
        {{ maxReportRows }}. Please alter your search criteria to reduce the number of results.
      </h4>

      <div
        class="custom-result"
        *ngIf="reportsResult.length > 0 && reportsResult.length < maxReportRows + 1"
      >
        <h4>
          Your report contains {{ reportsResult.length }}
          {{ reportsResult.length === 1 ? 'row' : 'rows' }}.
        </h4>

        <div [ngStyle]="{ opacity: loadingState ? '0' : '1' }">
          <div #resultsSection class="table-helper box-shadow">
            <table class="table-list" id="reports-table">
              <thead>
                <tr>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'user' }"
                    (click)="sortReport('user')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportUser"
                      triggers="hover"
                      placement="top"
                      >user</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'date' }"
                    (click)="sortReport('date')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportDate"
                      triggers="hover"
                      placement="top"
                      >date</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'pcn' }"
                    (click)="sortReport('pcn')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportPcn"
                      triggers="hover"
                      placement="top"
                      >PCN</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'stage' }"
                    (click)="sortReport('stage')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportStage"
                      triggers="hover"
                      placement="top"
                      >stage</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'decision' }"
                    (click)="sortReport('decision')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportDecision"
                      triggers="hover"
                      placement="top"
                      >decision</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'charge' }"
                    (click)="sortReport('charge')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportCharge"
                      triggers="hover"
                      placement="top"
                      >charge</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'progression' }"
                    (click)="sortReport('progression')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportProgression"
                      triggers="hover"
                      placement="top"
                      >progression</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'bespoke' }"
                    (click)="sortReport('bespoke')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportBespoke"
                      triggers="hover"
                      placement="top"
                      >bespoke</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'override' }"
                    (click)="sortReport('override')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportOverride"
                      triggers="hover"
                      placement="top"
                      >override</span
                    >
                  </td>
                  <td
                    class="filter"
                    [ngClass]="{ selected: reportsSort === 'ufu' }"
                    (click)="sortReport('ufu')"
                  >
                    <span
                      class="strong"
                      [ngbPopover]="reportsCopy.reportUfu"
                      triggers="hover"
                      placement="top"
                      >UFU</span
                    >
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let report of reportsResult; let index = index">
                  <td>{{ showUser(index) }}</td>
                  <td>{{ report.date | date : 'dd/MM/yyyy h:mm a' }}</td>
                  <td>
                    <a
                      *ngIf="report.letterHtml !== null"
                      class="link"
                      (click)="showRepLetter(modal, report.representationId)"
                      >{{ report.pcn }}</a
                    >
                    <div *ngIf="report.letterHtml === null">{{ report.pcn }}</div>
                  </td>
                  <td>{{ report.stageName }}</td>
                  <td>{{ report.decision }}</td>
                  <td>{{ report.fineNow }}</td>
                  <td>{{ report.progression }}</td>
                  <td>{{ report.bespoke}}</td>
                  <td>{{ report.override }}</td>
                  <td>{{ report.ufu }}</td>
                </tr>
                <tr>
                  <td colspan="5">{{ reportsResult.length }} rows</td>
                  <td colspan="5">£{{ totalFineAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modal let-c="close" let-d="dismiss">
  <div class="modal-container">
    <div class="close-icon black medium" (click)="d('Cross click')"></div>
    <div class="content">
      <h4><strong>PCN:</strong> {{ letter.pcn }}</h4>
      <p class="info">
        This is the letter that Response Master generated. The final, edited version may be
        different and will be in your notice-processing system.
      </p>
      <h4 *ngIf="letter.reasons.length > 0">
        <strong>Reasons:</strong>
        <span *ngIf="letter.reasons.length === 0">none</span>
        <span *ngFor="let reason of letter.reasons; let index = index">
          <span *ngIf="index !== 0">, </span>
          <span [innerHTML]="reason | safe : 'html'"></span>
        </span>
      </h4>
      <h4 *ngIf="letter.documents.length > 0">
        <strong>Documents:</strong>
        <span *ngIf="letter.documents.length === 0">none</span>
        <span *ngFor="let document of letter.documents; let index = index">
          <span *ngIf="index !== 0">, </span>
          <span [innerHTML]="document | safe : 'html'"></span>
        </span>
      </h4>
      <div id="letter-ready-id" [innerHTML]="letter.content | safe : 'html'"></div>
    </div>
  </div>
</ng-template>
